export { notificationVariablesByEventKind, isNotifiableEventKind } from "./registry"
export type { NotifiableEventKind } from "./registry"
export {
    actionLabels,
    categoryLabels,
    layerTypeLabels,
    resolvedVariables,
    supportsVariable,
} from "./variables"
export type { NotificationContext, ResolvedVariable } from "./variables"
export { isMentionNotification } from "./mentions"
export { buildCopy } from "./copy-registry"
export type { CopyRegistry } from "./copy-registry"
export { buildPushCopy } from "./push-copy"
export type { PushNotificationCopy } from "./push-copy"
